function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 0.514893C45.7614 0.514893 48 2.75347 48 5.51489V20.5149C48 23.2763 45.7614 25.5149 43 25.5149H5C2.23858 25.5149 0 23.2763 0 20.5149V5.51489C0 2.75347 2.23858 0.514893 5 0.514893H43ZM25 1.51489H43C45.2091 1.51489 47 3.30575 47 5.51489V20.5149C47 22.724 45.2091 24.5149 43 24.5149H25L25 1.51489ZM24 24.5149H5C2.79086 24.5149 1 22.724 1 20.5149V5.51489C1 3.30575 2.79086 1.51489 5 1.51489H24L24 24.5149Z",
  fill: "#C1C6C9"
});

var Svg2C = function Svg2C(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 26,
    viewBox: "0 0 48 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2C, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2c.7061f4c3.svg";
export { ForwardRef as ReactComponent };